import type { ImageId } from '../../assets/marketing/manifest';
import heroFrostFieldsLandscape from '../../assets/marketing-video/hero-frost-fields-landscape.mp4';
import heroFrostFieldsPortrait from '../../assets/marketing-video/hero-frost-fields-portrait.mp4';

/**
 * The films a hero can play, from `npm run gen:video` (brand/video/README.md).
 * Each opens on `poster`, a still of its first frame in the image set. The
 * stage paints the page's `<Hero image>`, which must be that still (`poster`),
 * and keeps it whenever the film does not play.
 */
export interface MarketingVideo {
  poster: ImageId;
  /** 1920×1080, for everything but an upright phone. */
  landscape: string;
  /** 720×1080 (2:3), cropped for upright phones. */
  portrait: string;
}

export type VideoId = 'hero-frost-fields';

export const VIDEOS: Record<VideoId, MarketingVideo> = {
  'hero-frost-fields': {
    poster: 'hero-frost-fields',
    landscape: heroFrostFieldsLandscape,
    portrait: heroFrostFieldsPortrait,
  },
};
